import {
  useProjectDesktopDelegation as useProjectDesktopDelegationCore,
  type ProjectDesktopDelegationPorts,
} from '../../../data/projects/hooks/useProjectDesktopDelegation';
import { agentHarnessClient } from '../../agent-harness/client';
import { streamHeaders } from '../../agent-harness/stream/stream-http';
import { getWorkHostPort } from '../../work-home/work-home-ports';

// One ports object. The executor calls read the host when they run.
const DESKTOP_DELEGATION_PORTS: ProjectDesktopDelegationPorts = {
  cancelComputerUseRun: (agentRunId) =>
    getWorkHostPort('desktop').cancelComputerUseRun(agentRunId),
  useIsExecutorStopSignalled: (childRunId) =>
    getWorkHostPort('desktop').useIsExecutorStopSignalled(childRunId),
  transport: agentHarnessClient,
  streamHeaders,
};

/** The Work chat's desktop delegation, bound to the rpa executor. */
export const useProjectDesktopDelegation = (
  args: Omit<Parameters<typeof useProjectDesktopDelegationCore>[0], 'ports'>
): ReturnType<typeof useProjectDesktopDelegationCore> =>
  useProjectDesktopDelegationCore({ ...args, ports: DESKTOP_DELEGATION_PORTS });
